// extracted by mini-css-extract-plugin
export const root = "initiative-gallery-module--root--3kt4j";
export const item = "initiative-gallery-module--item--1A5HR";
export const imageWrap = "initiative-gallery-module--imageWrap--3KQy-";
export const galleryArrow = "initiative-gallery-module--galleryArrow--2Pjqr";
export const prev = "initiative-gallery-module--prev--3Lszo";
export const next = "initiative-gallery-module--next--2Cthv";